import React, {useState, useEffect} from "react"
import { Redirect, Link } from 'react-router-dom'
import {Container, Row, Col, Form, Button, Image, Spinner, InputGroup } from "react-bootstrap"
import {FaSignInAlt, FaEye } from "react-icons/fa"
import N from '../lib/Network'
import AC from '../lib/AppConsts'
import S from '../lib/Security'
import jwt from "jwt-decode"
import AppConstants from "../lib/AppConsts"

var CryptoJS = require("crypto-js");

function passwordShow() {
    var x = document.getElementById("password");
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
}
const Login = () => {
    const [ToDashboard,setToDashboard] = useState(false);
    const [toManageUser,setToManageUser] = useState(false);
    const [toManageTenant,setToManageTenant] = useState(false);
    const [username,setUsername] = useState('');
    const [password,setPassword] = useState('');
    const [logingIn,setLogingIn] = useState(false);
    const [errors,setErrors] = useState({});
    
    var [data] = useState()
    data = {
        ToDashboard: ToDashboard,
        username: username,
        password: password,
        logingIn: logingIn
    };
    useEffect(() => getKeys(), []);

    function getKeys(){
      if(S.getPrivateKey() === '' && S.getPublicKey() === ''){
        N.getRSAApi('/getRsaKeys')
        .then(res => {
            let resObj = JSON.parse(res.data);
            let resJson = JSON.parse(resObj.responseJson);
            if(resJson.privateKey && resJson.publicKey){
                let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                // Decrypt
                var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
    
                var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
            }
        })
        .catch(err => {
            console.log("Error : "+err);
        });
      }
    }
    const validateForm = () => {
        let formIsValid = true;
        let err = {};
        if(username ==="" || username.length<=0){
          err["username"] = "Email address cannot be empty";
          formIsValid= false;
        }
        if(password ==="" || password.length<=0){
          err["password"] = "Password cannot be empty";
          formIsValid= false;
        }
        setErrors(err);
        return formIsValid;
    }
  
    const handleChange= (event) =>{
        if(event.target.name === 'username'){
         errors["username"] ="";
          setUsername(event.target.value);
        }
        if(event.target.name === 'password'){
          errors["password"] ="";
          setPassword(event.target.value);
           
        }
      }

    const _handleSubmit = (e) => {
        e.preventDefault()
        let isThisValidForm = false;
        if(validateForm()){
            isThisValidForm = true;
        }
  
        if(isThisValidForm){
            localStorage.clear();
            N.postApi('doLogin',data)
            .then(res => {
                let resObj = S.getDecryptedJSON(res);
                localStorage.setItem("authorization", resObj.jwttoken);
                if(resObj.jwttoken){
                    localStorage.setItem("isLoggedIn", "true");
                }
                else{
                    localStorage.setItem("isLoggedIn", "false");
                }
                var user = jwt(resObj.jwttoken);
                console.log("user:"+JSON.stringify(user));
                let er = {};
                if(user.Message !== undefined){
                    if(user.Message == "User is inactive"){
                        er["loginError"] = user.Message;
                        setErrors(er);
                    }else if(user.Message == "UserPassword is wrong"){
                        er["password"] = user.Message;
                        setErrors(er);
                    }else if(user.Message == "UserName is  wrong"){
                        er["username"] = user.Message;
                        setErrors(er);
                    }
                }
                localStorage.setItem('username', username);
                localStorage.setItem('userId',user.userId);
                localStorage.setItem('tenantId',user.tenantId);
                if(user.productRole !== undefined){
                user.productRole.map((item) => {
                    if (item.productId === AC.PRODUCT_P2P) {
                        localStorage.setItem('isP2PRole', true); 
                    }else if (item.productId === AC.PRODUCT_ERFX) {
                        localStorage.setItem('isERFXRole', true); 
                    }else if (item.productId === AC.PRODUCT_TNE) {
                        localStorage.setItem('isTNERole', true); 
                    }else if (item.productId === AC.PRODUCT_Vendor_Empanlement) {
                        localStorage.setItem('isVendorEmpanlementRole', true); 
                    }else if (item.productId === AC.PRODUCT_CMS) {
                        localStorage.setItem('isCMSRole', true); 
                    }else if (item.productId === AC.PRODUCT_ASSET_MANAGMENT) {
                        localStorage.setItem('isASSETMANAGMENTRole', true); 
                    }
                     if (item.productId === AC.PRODUCT_RENT_AND_UTILITY) {
                        localStorage.setItem('isRentANDUtilityRole', true); 
                    }
                });
            }
                user?.activity?.map((item) => {
                    if (item.activityId === AC.ACTIVITY_CREATE_USER_ROLE_ID) {
                        localStorage.setItem('isCreateUserRole', true);
                    }else if (item.activityId === AC.ACTIVITY_EDIT_USER_ROLE_ID) {
                        localStorage.setItem('isEditUserRole', true);
                    } else if (item.activityId === AC.ACTIVITY_VIEW_USER_ROLE_ID) {
                        localStorage.setItem('isViewUserRole', true);
                    } else if (item.activityId === AC.ACTIVITY_CREATE_TENANT_ROLE_ID) {
                        localStorage.setItem('isCreateTenantRole', true);
                        localStorage.setItem('isViewOCRRole', true);
                    } else if (item.activityId === AC.ACTIVITY_VIEW_TENANT_ROLE_ID) {
                        localStorage.setItem('isViewTenantRole', true);
                    }else if (item.activityId === AC.ACTIVITY_MODIFY_TENANT_ROLE_ID) {
                        localStorage.setItem('isModifyTenantRole', true);
                    }else if (item.activityId === AC.ACTIVITY_CREATE_TENANT_USER_ROLE_ID) {
                        localStorage.setItem('isCreateTenantUserRole', true);
                    }else  if (item.activityId === AC.ACTIVITY_MODIFY_TENANT_USER_ROLE_ID) {
                        localStorage.setItem('isModifyTenantUserRole', true);
                    }else if (item.activityId === AC.ACTIVITY_MANAGE_TENANT_USER_Role_ROLE_ID) {
                        localStorage.setItem('isViewTenantUserRole', true);
                    }else if (item.activityId === AC.ACTIVITY_VIEW_MIS_ROLE_ID) {
                        localStorage.setItem('isViewMISRole', true);
                    }else if (item.activityId === AC.ACTIVITY_COMPANY_SETTING_ROLE_ID) {
                        localStorage.setItem('isCompanySettingRole', true);
                    }
                    else if (item.activityId === AC.ACTIVITY_EXPENZING_SPOC_ROLE_ID) {
                        localStorage.setItem('isExpenzingSPOC', true);
                    }
                });
                setToDashboard(true)
                setToManageUser(true)
                setToManageTenant(true)
                setLogingIn(false)
            })
            .catch(err => {
                console.log("Error : "+JSON.stringify(err.response.data));
            });
        }
    }
        if ((localStorage.getItem("isViewTenantUserRole"))==="true") {
            console.log("toDash");
            return <Redirect to='dashboard' />
        }else if((localStorage.getItem("isViewUserRole"))==="true"){
            console.log("manageuser");
            return <Redirect to='manageuser' />
        }else if((localStorage.getItem("isViewTenantRole"))==="true"){
            console.log("managetenant");
            return <Redirect to='managetenant' />
        }else if((localStorage.getItem("isP2PRole"))==="true"){
            console.log("dashboard");
            return <Redirect to='dashboard' />
        }

  
    return (
        <Container fluid className="form-body p-0">
            <Row>
                <Col lg='7'>
                    <div className="img-holder">
                        <div className="bg"></div>
                        <div className="info-holder">
                            <h3>Expense Management Suite</h3>
                        </div>
                    </div>
                </Col>
                <Col lg='5'>
                    <div className="form-holder">
                        <div className="form-content">
                            <div className="form-items">
                                <div className="website-logo-inside mb-4">
                                    <Link href="index.html">
                                        <div className="logo">
                                            <Image className="logo-size hoverImage" src={require('../img/expenzelogo.jpg')} />
                                        </div>
                                    </Link>
                                </div>
                                <div className="page-links">
                                    <h3>Login</h3>
                                </div>
                                <div name="loginError">
                                <h4><div className="invalid-feedback">{errors["loginError"]}</div>
                                    </h4>
                                </div>
                                <Form onSubmit={e => _handleSubmit(e)} className="form" noValidate>
                                    <Form.Group className="mb-3">
                                        <Form.Control id="email" type="text" placeholder='User Name' name="username" onChange={handleChange} />
                                        <div className="invalid-feedback">{errors["username"]}</div>
                                    </Form.Group>
                                    <InputGroup className="mb-3">
                                        <Form.Control id="password" type="password" placeholder='Password' name="password" onChange={handleChange} />
                                        <InputGroup.Text id="basic-addon2"><FaEye className='' onClick={passwordShow} /></InputGroup.Text>
                                        <div className="invalid-feedback">{errors["password"]}</div>
                                    </InputGroup>
                                    <div className="form-button text-left">
                                        <Button className="btnlogin" type="submit">
                                            {logingIn && (
                                                <Spinner className='mr-2' animation='border' size='1.2rem'/>
                                            )}
                                            {!logingIn && (
                                                <FaSignInAlt className='mr-2' size='1.2rem'/>
                                            )}
                                            Login
                                        </Button>
                                        <Link to="/#" id="forgotPass" className="float-right">Forget password?</Link>
                                    </div>
                                </Form>
                                <div className="footerText mt-4">
                                    <p>Copyright &#169; 2022 Nexstep Infotech Pvt. Ltd. All rights reserved.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
export default Login;